export default __webpack_public_path__ + "static/media/icons-home-navigation-black.14f24909.svg";